import { NeveMeasurementsComponent } from './neve-measurements.component';
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { QmDirectivesModule } from '~app/components/qm-directives/qm-directives.module';
import { NeveMeasurementsTableComponent } from './neve-measurements-table.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NeveBaseComponent } from './base/neve-base.component';
import { ValmetDnaService } from './valmet-dna.service';
import { NeveMeasurementsToolbarComponent } from './neve-measurements-toolbar.component';
import { NeveMeasurementsMapLayersService } from './neve-measurements-map-layers.service';

@NgModule({
  declarations: [ NeveBaseComponent, NeveMeasurementsComponent, NeveMeasurementsTableComponent, NeveMeasurementsToolbarComponent ],
  imports: [ CommonModule, TranslateModule, NgbNavModule, NgbTooltipModule, QmDirectivesModule ],
  exports: [ NeveBaseComponent, NeveMeasurementsComponent, NeveMeasurementsTableComponent, NeveMeasurementsToolbarComponent ],
  providers: [ ValmetDnaService, NeveMeasurementsMapLayersService ]
})
export class NeveModule {

}
